module.exports = __webpack_public_path__ + "static/media/empty-avatar.670809bf.jpg";